module.exports = __webpack_public_path__ + "static/PrestaShop-1b5b3e1f7dd6e395fc512a855e97e771.svg";